import { makeStyles } from "@material-ui/core/styles";

export const dialogUpdateGoalStyles = makeStyles((theme) => ({
  answer: {
    height: "350px",
    border: "1px solid #A7BBD4",
    borderRadius: "10px",
    "& .MuiButton-label": {
      display: "block",
    },
    "& img": {
      width: "100%",
    },
    "& .answerDescription": {
      color: "black",
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: theme.typography.pxToRem(16),
    },
  },
  title: {
    marginBlockEnd: 8,
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 500,
  },
  subtitle: {
    marginBlockEnd: 48,
    fontSize: theme.typography.pxToRem(20),
    fontFamily: "Lato",
    fontWeight: 400,
  },
  actions: {
    justifyContent: "flex-end !important",
    alignContent: "flex-end",
    alignItems: "flex-end",
    "& button:nth-child(1)": {
      color: "#0344DC",
      "&:hover": {
        background: "none",
        color: "#0236B0",
      },
    },
    "& button:nth-child(2)": {
      color: "#0344DC",
      borderColor: "#0344DC",
      borderRadius: 100,
      "& svg path": {
        fill: "#22D9BB",
      },
      "&:hover": {
        background: "#E6F1FF",
      },
      "&[disabled]": {
        background: "#F1F5F9 !important",
        border: "none",
        color: "#D1D8DF",
        "& svg path": {
          fill: "#D1D8DF",
        },
      },
    },
  },
}));
